<template>
    <div class="rel-serv-plans-component">

        <b-modal hide-footer size="xl" centered ref="modal-serv" scrollable title="Agregar Servicios al Plan">
            <ul id="addListServ">
                <li v-for="(serv, index) of getServArray" :key="serv.id">
                    <div class="row align-items-center">
                        <div class="col-md-4">
                            <div class="float">{{ serv.servicio }}</div>
                        </div>
                        <div class="col-md-2">
                            <input placeholder="Limite" type="text" class="al-inputs"
                                   v-model="getServArray[index]['limite']">
                        </div>
                        <div class="col-md-2">
                            <input placeholder="Copago" type="text" class="al-inputs"
                                   v-model="getServArray[index]['copago']">
                        </div>
                        <div class="col-md-2">
                            <input placeholder="Descuento" type="text" class="al-inputs"
                                   v-model="getServArray[index]['descuento']">
                        </div>
                        <div class="col-md-2">
                            <input placeholder="Orden" type="text" class="al-inputs"
                                   v-model="getServArray[index]['orden']">
                        </div>
                    </div>
                </li>
            </ul>
            <div class="row">
                <div class="col-md-12">
                    <button type="button" class="btn btn-primary" v-on:click="guardar()">Guardar</button>
                </div>
            </div>
        </b-modal>

        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-sm-2 ">
                            <select v-model="plan_selected" data-select="on" data-name-input="Estado">
                                <option :value="-1">Selecciona un Plan</option>
                                <option v-for="plan in planes" :value="plan.id" :key="plan.id">
                                    {{ plan.paquete }}
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-sm-2">
                            <button type="button" class="formSubmit" v-on:click="filterRel">Filtrar</button>
                        </div>
                        <div class="col-12 col-sm-2 offset-sm-6">
                            <button v-if="modificar==true" type="button" class="formSubmit" v-on:click="updateRel">
                                Actualizar
                            </button>
                            <button v-if="emptytable==true" type="button" class="formSubmit" v-b-modal.modal-serv
                                    v-on:click="openModal">Agregar
                            </button>
                        </div>
                    </div>
                </div>
                <div class="barSettings">
                    <div class=" row">
                        <div class="col-12  col-xl-2 mb-3 mb-sm-0">
                           <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                          :total-rows="pagination.total"
                                          :per-page="pagination.per_page" aria-controls="my-table"
                                          v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12  col-xl-6 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs" v-model="filter" type="search"
                                   placeholder="Buscar por palabra">
                        </div>
                        <div class="col-12  col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table responsive id="my-table" striped hover :fields="fields" :filter="filter" :busy="isBusy"
                                 :items="pagination.data" show-empty>

                            <template #empty="scope">
                                <h4 class="emptyRow">
                                    No hay datos para mostrar.
                                </h4>
                            </template>
                            <template #cell(Plan)="{item}">
                                <span v-if="item.package"> {{ item.package['paquete'] }}</span>
                                <span v-else>Sin Plan </span>
                            </template>
                            <template #cell(Servicio)="{item}">
                                <span v-if="item.services"> {{ item.services['servicio'] }}</span>
                                <span v-else>Sin Servicio</span>
                            </template>
                            <template #cell(Limite)="data">
                                {{ data.item.slimite }}
                            </template>
                            <template #cell(Copago)="data">
                                {{ data.item.copago }}
                            </template>
                            <template #cell(Descuento)="data">
                                {{ data.item.descuento }}
                            </template>
                            <template #cell(Orden)="data">
                                {{ data.item.orden }}
                            </template>

                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)" v-on:click="modificar=true;">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)" v-on:click="">Borrar</a>
                                    </div>
                                </div>
                            </template>

                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                        </b-table>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>

import {myMixins} from "../mixins/myMixins";
import {packagesService} from "../../Services/Packages.service";
import {relservpackService} from "../../Services/Relservpack.service";
import {servicesService} from "../../Services/Services.service";

export default {
    name: "Relacion_Servicios_y_Paquetes",
    mixins: [myMixins],
    data() {
        return {
            showModal: false,
            modificar: false,
            emptytable: false,
            isBusy: false,
            filter: null,
            fields: [
                {key: 'Plan'},
                {key: 'Servicio'},
                {key: 'Limite'},
                {key: 'Copago'},
                {key: 'Descuento'},
                {key: 'Orden'},
                {key: 'Acciones'}
            ],
            params: {
                limit: 10,
                page: 1,
                where: []
            },
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            plan_selected: 0,
            planes: [],
            packagesArray: [],
            getServArray: [],
            tituloBtn: 'Agregar',
            resp: '',
            currentFilterServ: [],
        }
    },
    methods: {
        async getData() {
            this.pagination = await relservpackService.getMany(this.params);
        },
        async index() {
            this.isBusy = true;
            this.params.where.push({
                field: 'slimite',
                operator: '!=',
                value: 0
            });
            this.planes = await packagesService.getMany();
            await this.getData();
            this.isBusy = false;
        },
        async filterRel() {

            this.isBusy = true;
            this.params.where = [{
                field: 'package_id',
                operator: '=',
                value: this.plan_selected
            }, {
                field: 'slimite',
                operator: '!=',
                value: 0
            }];
            this.pagination = await relservpackService.getMany(this.params);
            this.currentFilterServ = this.pagination.data;
            if (this.pagination.data.length > 0) {
                this.modificar = true;
                this.emptytable = false;
            } else {
                this.emptytable = true;
                this.showAlert('warning', 'No se encontraron resultados');
            }
            this.isBusy = false;
        },
        async updateRel() {
            let resp = '';
            //PIDO LOS 24 SERVICIOS
            resp = await servicesService.getServByKind(0);
            for (let servicios of resp.data) {
                for (const selectedServ of this.currentFilterServ) {
                    if (servicios.id == selectedServ.services_id) {
                        servicios.limite = selectedServ.slimite;
                        servicios.copago = selectedServ.copago;
                        servicios.descuento = selectedServ.descuento;
                        servicios.orden = selectedServ.orden;
                    }
                }
            }
            this.getServArray = resp.data;
            this.$refs['modal-serv'].show();
        },
        async guardar() {

            //INSERTAR
            let resp = '';
            let planSelected = this.plan_selected;
            let servSelected = this.getServArray;
            let merge = {servSelected, planSelected};

            if (this.modificar) {
                resp = relservpackService.updateOne(planSelected, merge);
            } else {
                resp = relservpackService.saveOne(merge);
            }

            if (resp.process === 'success') {
                this.getAlert(resp.process);
                await this.index();
            } else {
                this.getAlert(resp.process);
            }

        },
        async openModal() {
            //TRAIGO LOS SERVICIOS BÀSICOS
            let resp = '';
            resp = await servicesService.getServByKind(2);
            this.getServArray = resp.data;
            this.$refs['modal-serv'].show();
        },
        async onChange(page) {
            this.params.page = page;
            await this.getData();
        },
        changeLimit() {
            this.index();
        }
    },
    mounted() {
        this.index();
    },
}
</script>

<style scoped>
#packages-component {
    padding: 0;
    position: relative;
    height: 100%;
    width: 100%;
}
</style>
